const iTuneCategories = [
  {
    id: "Arts",
    value: "Arts",
    childrens: [
      {
        id: "Design",
        value: "Design",
      },
      {
        id: "Fashion and Beauty",
        value: "Fashion and Beauty",
      },
      {
        id: "Food",
        value: "Food",
      },
      {
        id: "Literature",
        value: "Literature",
      },
      {
        id: "Performing Arts",
        value: "Performing Arts",
      },
      {
        id: "Visual Arts",
        value: "Visual Arts",
      },
    ],
  },
  {
    id: "Business",
    value: "Business",
    childrens: [
      {
        id: "Business News",
        value: "Business News",
      },
      {
        id: "Careers",
        value: "Careers",
      },
      {
        id: "Investing",
        value: "Investing",
      },
      {
        id: "Management and Marketing",
        value: "Management and Marketing",
      },
      {
        id: "Shopping",
        value: "Shopping",
      },
    ],
  },
  {
    id: "Comedy",
    value: "Comedy",
    childrens: [],
  },
  {
    id: "Education",
    value: "Education",
    sub: [
      {
        id: "Educational Technology",
        value: "Educational Technology",
      },
      {
        id: "Higher Education",
        value: "Higher Education",
      },
      {
        id: "K-12",
        value: "K-12",
      },
      {
        id: "Language Courses",
        value: "Language Courses",
      },
      {
        id: "Training",
        value: "Training",
      },
    ],
  },
  {
    id: "Games and Hobbies",
    value: "Games and Hobbies",
    childrens: [
      {
        id: "Automotive",
        value: "Automotive",
      },
      {
        id: "Aviation",
        value: "Aviation",
      },
      {
        id: "Hobbies",
        value: "Hobbies",
      },
      {
        id: "Other Games",
        value: "Other Games",
      },
      {
        id: "Video Games",
        value: "Video Games",
      },
    ],
  },
  {
    id: "Government and Organizations",
    value: "Government and Organizations",
    childrens: [
      {
        id: "Local",
        value: "Local",
      },
      {
        id: "National",
        value: "National",
      },
      {
        id: "Non-Profit",
        value: "Non-Profit",
      },
      {
        id: "Regional",
        value: "Regional",
      },
    ],
  },
  {
    id: "Health",
    value: "Health",
    childrens: [
      {
        id: "Alternative Health",
        value: "Alternative Health",
      },
      {
        id: "Fitness and Nutrition",
        value: "Fitness and Nutrition",
      },
      {
        id: "Self-Help",
        value: "Self-Help",
      },
      {
        id: "Sexuality",
        value: "Sexuality",
      },
    ],
  },
  {
    id: "Kids and Family",
    value: "Kids and Family",
  },
  {
    id: "Music",
    value: "Music",
  },
  {
    id: "News and Politics",
    value: "News and Politics",
  },
  {
    id: "Religion and Spirituality",
    value: "Religion and Spirituality",
    childrens: [
      {
        id: "Buddhism",
        value: "Buddhism",
      },
      {
        id: "Christianity",
        value: "Christianity",
      },
      {
        id: "Hinduism",
        value: "Hinduism",
      },
      {
        id: "Islam",
        value: "Islam",
      },
      {
        id: "Judaism",
        value: "Judaism",
      },
      {
        id: "Other",
        value: "Other",
      },
      {
        id: "Spirituality",
        value: "Spirituality",
      },
    ],
  },
  {
    id: "Science and Medicine",
    value: "Science and Medicine",
    childrens: [
      {
        id: "Medicine",
        value: "Medicine",
      },
      {
        id: "Natural Sciences",
        value: "Natural Sciences",
      },
      {
        id: "Social Sciences",
        value: "Social Sciences",
      },
    ],
  },
  {
    id: "Society and Culture",
    value: "Society and Culture",
    childrens: [
      {
        id: "History",
        value: "History",
      },
      {
        id: "Personal Journals",
        value: "Personal Journals",
      },
      {
        id: "Philosophy",
        value: "Philosophy",
      },
      {
        id: "Places and Travel",
        value: "Places and Travel",
      },
    ],
  },
  {
    id: "Sports and Recreation",
    value: "Sports and Recreation",
    childrens: [
      {
        id: "Amateur",
        value: "Amateur",
      },
      {
        id: "College and High School",
        value: "College and High School",
      },
      {
        id: "Outdoor",
        value: "Outdoor",
      },
      {
        id: "Professional",
        value: "Professional",
      },
    ],
  },
  {
    id: "Technology",
    value: "Technology",
    childrens: [
      {
        id: "Gadgets",
        value: "Gadgets",
      },
      {
        id: "Tech News",
        value: "Tech News",
      },
      {
        id: "Podcasting",
        value: "Podcasting",
      },
      {
        id: "Software How-To",
        value: "Software How-To",
      },
    ],
  },
  {
    id: "TV and Film",
    value: "TV and Film",
  },
];

export default iTuneCategories;
